import React from 'react';
import { Form, FormGroup, FormControl, Button } from 'react-bootstrap';
import config from '../../../config';
import { Chart, registerables } from 'chart.js';
import Select from 'react-select';
import moment from 'moment';
import utils from '../../utils';
import { oeeReportService } from '../../_services/oeeReport.service';
import {
    getMonthlyTargetArrayForYear,
    loadMonthlyTargetsFromAccount,
    cacheMonthlyTargetsInLocalStorage,
    getCurrentMonthTarget,
    readCachedMonthlyTargets,
} from '../../utils/monthlyTargets';
const {
    buildMetricIndex,
    formatOeeMetric,
    isCalculatedMetric,
    metricTitle,
} = require('../DailyOEEReport/oeeReportPresentation');

//Chart.register(...registerables);

class MonthlyOEEReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            target: 0,
            monthTargets: [],
            selectedYear: moment().year(),
            years: [],
            selectedMachine: [],
            selectedCategory: 99,
            machineStr: '',
            originMachines: [],
            categories: [{ value: 99, text: 'All' }, { value: 1, text: 'Machine' }, { value: 2, text: 'Line' }, { value: 3, text: 'SMT' }],
            loadingReport: false,
            revalidatingReport: false,
            reportError: '',
            reportRetryable: true,
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; position: relative; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
            tableHeader: '<table id="monthlyoeereport" class="highlight-table" border=1; cellspacing=0/>'
                + '<tr>'
                + '<th style = "">Month</th>'
                + '<th style = "">Jan</th>'
                + '<th style = "">Feb</th>'
                + '<th style = "">Mar</th>'
                + '<th style = "">Apr</th>'
                + '<th style = "">May</th>'
                + '<th style = "">Jun</th>'
                + '<th style = "">Jul</th>'
                + '<th style = "">Aug</th>'
                + '<th style = "">Sep</th>'
                + '<th style = "">Oct</th>'
                + '<th style = "">Nov</th>'
                + '<th style = "">Dec</th>'
                + '<th style = "">YTD Average</th>'
                + '</tr>',
        };
        this.node = React.createRef();
        this.reportRequestSequence = 0;
        this.activeReportRequest = null;
    }

    componentWillMount() {
        let yearArray = [];
        for (let i = this.state.selectedYear; i >= 2019; i--) {
            yearArray.push(i);
            this.setState({
                years: yearArray
            });
        }

        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    let data = [],
                        dynamicCategories = [{ text: 'All', value: 99 }];
                    // login successful if there's a user in the response
                    if (machine) {
                        machine.forEach(item => {
                            data.push({ 'id': item.id, 'label': item.machine, 'category': item.category, 'value': item.machine });
                            if (item.description && !dynamicCategories.some(cat => cat.value === item.category)) {
                                dynamicCategories.push({ text: item.description, value: item.category });
                            }
                        })

                        this.setState({ machines: data });
                        this.setState({ originMachines: data });
                        dynamicCategories.length > 1 && this.setState({ categories: dynamicCategories });
                        this.loadMonthlyTargets().then(() => this.buildHtmlTable());
                    }

                    return machine;
                });
    }

    componentDidMount() {
        const node = this.node;
        var ctx = document.getElementById("monthlyOEEchart");
        ctx.style.backgroundColor = 'rgba(53,53,53,255)';
        Chart.defaults.global.defaultFontColor = '#B8B3B3';
        window.monthlyOEEchart = new Chart(ctx, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'Average',
                        data: [],
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132)'
                    },
                    {
                        label: 'Target',
                        data: [],
                        type: 'line',
                        fill: false,
                        borderColor: "rgb(54, 162, 235)"
                    },
                ],
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            },
            options: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        boxWidth: 20,
                        padding: 20,
                        generateLabels: function (chart) {
                            return chart.data.datasets.map(function (dataset, i) {
                                const iconCanvas = document.createElement('canvas');
                                iconCanvas.width = 20;
                                iconCanvas.height = 20;
                                const ictx = iconCanvas.getContext('2d');
                                if (i === 0) {
                                    ictx.fillStyle = 'rgba(255, 99, 132, 1)';
                                    ictx.fillRect(0, 0, 10, 20);
                                    ictx.fillStyle = 'rgba(40, 167, 69, 1)';
                                    ictx.fillRect(10, 0, 10, 20);
                                } else if (i === 1) {
                                    ictx.strokeStyle = "rgb(54, 162, 235)";
                                    ictx.lineWidth = 3;
                                    ictx.beginPath();
                                    ictx.moveTo(0, 10);
                                    ictx.lineTo(20, 10);
                                    ictx.stroke();
                                }
                                return {
                                    text: dataset.label,
                                    fillStyle: dataset.backgroundColor,
                                    hidden: !chart.isDatasetVisible(i),
                                    strokeStyle: dataset.borderColor,
                                    pointStyle: iconCanvas,
                                    datasetIndex: i
                                };
                            });
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF3"
                        }

                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF2"
                        },
                        ticks: {
                            min: 0,
                            max: 100
                        }
                    }]
                },
                title: {
                    display: true,
                    text: ['PRODUCTION MONTHLY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Monthly Target: 0% ']

                },
                plugins: {
                    labels: false
                }
            },
        });
    }

    loadMonthlyTargets = () => {
        const user = localStorage.getItem('user');
        if (!user) return Promise.resolve();
        const accountId = JSON.parse(user).accountId;
        return fetch(`${config.apiUrl}/getAccountTarget?account_id=${accountId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        })
            .then((res) => (res.ok ? res.json() : null))
            .then((account) => {
                const { oee, productivity } = loadMonthlyTargetsFromAccount(account || {});
                cacheMonthlyTargetsInLocalStorage(oee, productivity);
                const monthTargets = getMonthlyTargetArrayForYear(oee, this.state.selectedYear);
                const target = getCurrentMonthTarget(oee, this.state.selectedYear);
                this.setState({ monthTargets, target });
            })
            .catch(() => Promise.resolve());
    };

    tdWrap(content, target, metric) {
        let style = '';
        const title = metricTitle(metric);
        if (isCalculatedMetric(metric) && Number(metric.oee) >= Number(target)) {
            style = ' style="color: #28a745;"';
        }
        const titleAttribute = title ? ' title="' + title + '"' : '';
        return '<td' + style + titleAttribute + '>' + content + '</td>';
    }

    buildHtmlTable() {
        const reportYear = String(this.state.selectedYear);
        const reportCategory = this.state.selectedCategory;
        const reportMachines = this.state.selectedMachine;
        const requestIdentity = {
            id: ++this.reportRequestSequence,
            key: JSON.stringify([reportYear, reportCategory, reportMachines]),
        };
        this.activeReportRequest = requestIdentity;
        const isActiveRequest = () => Boolean(this.activeReportRequest)
            && this.activeReportRequest.id === requestIdentity.id
            && this.activeReportRequest.key === requestIdentity.key;
        const request = oeeReportService.getMonthly({
            year: reportYear,
            category: reportCategory,
            machines: reportMachines,
        });
        if (request.data) {
            this.applyMonthlyReport(request.data, reportYear);
        }
        this.setState({
            loadingReport: !request.data,
            revalidatingReport: Boolean(request.data),
            reportError: '',
            reportRetryable: true,
        });
        return request.revalidate
            .then((report) => {
                if (!isActiveRequest()) return report;
                this.applyMonthlyReport(report, reportYear);
                this.setState({
                    loadingReport: false,
                    revalidatingReport: false,
                    reportError: '',
                    reportRetryable: true,
                });
                return report;
            })
            .catch((error) => {
                if (!isActiveRequest()) return null;
                const retryable = !error || error.retryable !== false;
                this.setState({
                    loadingReport: false,
                    revalidatingReport: false,
                    reportError: retryable
                        ? 'OEE report unavailable. Retry.'
                        : (error.message || 'OEE report unavailable.'),
                    reportRetryable: retryable,
                });
                return null;
            });
    }

    applyMonthlyReport(report, reportYear = String(this.state.selectedYear)) {
        const { tableStyle, tableHeader } = this.state;
        const cellIndex = buildMetricIndex(
            report.cells,
            cell => cell.machine + '|' + cell.period
        );
        const machineSummaryIndex = buildMetricIndex(
            report.machineSummaries,
            summary => summary.machine
        );
        const periodSummaryIndex = buildMetricIndex(
            report.periodSummaries,
            summary => summary.period
        );
        const periods = Array.from({ length: 12 }, (_unused, index) => (
            reportYear + '-' + String(index + 1).padStart(2, '0')
        ));
        const monthTargets = this.state.monthTargets.length
            ? this.state.monthTargets
            : new Array(12).fill(this.state.target);
        const chartTargets = monthTargets.map(target => {
            const numericTarget = Number(target);
            return Number.isFinite(numericTarget) ? numericTarget : target;
        });

        let html = '';
        (report.machineSummaries || []).forEach(machineSummary => {
            html += '<tr>';
            html += this.tdWrap(machineSummary.machine);
            periods.forEach((period, index) => {
                const metric = cellIndex.get(machineSummary.machine + '|' + period);
                html += this.tdWrap(
                    formatOeeMetric(metric),
                    monthTargets[index],
                    metric
                );
            });
            const suppliedSummary = machineSummaryIndex.get(machineSummary.machine);
            html += this.tdWrap(
                formatOeeMetric(suppliedSummary),
                this.state.target,
                suppliedSummary
            );
            html += '</tr>';
        });

        html += '<tr>';
        html += this.tdWrap('Average');
        const chartValues = periods.map((period, index) => {
            const metric = periodSummaryIndex.get(period);
            html += this.tdWrap(
                formatOeeMetric(metric),
                monthTargets[index],
                metric
            );
            return isCalculatedMetric(metric) ? Number(metric.oee) : null;
        });
        html += this.tdWrap(
            formatOeeMetric(report.overallSummary),
            this.state.target,
            report.overallSummary
        );
        html += '</tr>';

        html += '<tr>';
        html += this.tdWrap('Target');
        monthTargets.forEach(target => {
            html += this.tdWrap(target);
        });
        html += this.tdWrap(this.state.target + '%');
        html += '</tr>';

        const safeHTML = utils.sanitizeVoidTags((tableStyle + tableHeader + html)
            .replaceAll('</img>', '')
            .replaceAll('</input>', '')
            .replaceAll('</br>', '<br/>')
            .replaceAll('</hr>', '<hr/>'));
        this.setState({ table: safeHTML });
        this.drawChart(chartValues, chartTargets);
        return report;
    }
    exportExcel() {
        utils.tableToExcel('datatable', 'Report', 'MonthlyOEEReport_' + this.state.selectedYear + '.xls');
    };

    drawChart(m, t) {
        const backgroundColors = m.map((val, index) => (val >= t[index] ? 'rgba(40, 167, 69, 0.8)' : 'rgba(255, 99, 132, 0.8)'));
        const borderColors = m.map((val, index) => (val >= t[index] ? 'rgb(40, 167, 69)' : 'rgb(255, 99, 132)'));
        window.monthlyOEEchart.data.datasets[0].backgroundColor = backgroundColors;
        window.monthlyOEEchart.data.datasets[0].borderColor = borderColors;
        window.monthlyOEEchart.data.datasets[0].data = m;
        window.monthlyOEEchart.data.datasets[1].data = t;
        window.monthlyOEEchart.options.title.text = ['PRODUCTION MONTHLY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Monthly Target: ' + this.state.target + '% '];
        window.monthlyOEEchart.update();
    }

    optionClicked(optionsList) {
        this.setState({ machines: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ selectedMachine: optionsList }, () => this.buildHtmlTable());
    }

    selectCategory(selectedCategory) {
        const machines = selectedCategory === 99
            ? this.state.originMachines
            : this.state.originMachines.filter(machine => (
                Number(machine.category) === selectedCategory
            ));
        const allowedMachines = new Set(machines.map(machine => machine.value));
        const selectedMachine = selectedCategory === 99
            ? []
            : (this.state.selectedMachine || []).filter(machine => {
                const machineName = typeof machine === 'string'
                    ? machine
                    : machine && (machine.value || machine.label);
                return allowedMachines.has(machineName);
            });
        this.setState({
            machines,
            selectedCategory,
            selectedMachine,
        }, () => this.buildHtmlTable());
    }

    render() {
        const { tableStyle, tableHeader, tableContent } = this.state;
        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8"
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d"
        };
        return (
            <div class="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Year:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedYear} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        const selectedYear = e.target.value;
                                        const { oee } = readCachedMonthlyTargets();
                                        const monthTargets = getMonthlyTargetArrayForYear(oee, selectedYear);
                                        this.setState({
                                            selectedYear,
                                            monthTargets,
                                            target: monthTargets[0],
                                        }, () => this.buildHtmlTable());
                                    } else {
                                        delete this.state.selectedYear;
                                    }
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.years.map((year) => {
                                        return <option key={year} value={year}>{year}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label> Category:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedCategory} onChange={(e) => {
                                    const selectedCategory = Number(e.target.value);
                                    this.selectCategory(selectedCategory);
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.categories.map((category) => {
                                        return <option key={category.value} value={category.value}>{category.text}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{'   '}
                        {this.state.selectedCategory != 99 && <FormGroup controlId="formInlineName">
                            <div class="col-xs-2" style={{ marginTop: '10px' }}>
                                <Form.Label> Items:</Form.Label></div>{' '}
                            <div class="col-xs-10" style={{ minWidth: '200px' }}>
                                <Select
                                    options={this.state.machines}
                                    value={this.state.selectedMachine}
                                    isMulti
                                    onChange={this.selectedBadgeClicked.bind(this)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </div>
                        </FormGroup>}{' '}
                        <Button
                            bsStyle="primary"
                            style={{ float: "right", margin: 10 }}
                            onClick={(e) => {
                                e.preventDefault();
                                this.buildHtmlTable();
                            }}>Show</Button>
                    </Form>
                    {this.state.loadingReport ? <div>Loading OEE report…</div> : null}
                    {this.state.revalidatingReport ? <div>Refreshing OEE report…</div> : null}
                    {this.state.reportError ? <div role="alert">
                        {this.state.reportError}{' '}
                        {this.state.reportRetryable ? <Button
                            bsStyle="primary"
                            onClick={() => this.buildHtmlTable()}>Retry</Button> : null}
                    </div> : null}
                    <canvas id="monthlyOEEchart" width="600" height="200" ref={node => (this.node = node)} style={{ marginTop: '10px' }}></canvas>
                    {this.state.table ? <div style={{ width: "100%" }}><Button
                        bsStyle="primary"
                        style={{ float: "right", margin: 10 }}
                        onClick={e => this.exportExcel()}>Export</Button></div> : ''}
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" class="container" style={{ overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: this.state.table }} />
            </div>
        );
    }
}

export { MonthlyOEEReport };
